export default __webpack_public_path__ + "static/media/cbseHero.e15dd7c5.png";